import React from "react";
import caveatColor from "../../caveatColor";
import Avatar from "material-ui/Avatar";

export const AVATAR_SIZE = 16;

// const containerStyle = maxCaveats => ({
//   width: (AVATAR_SIZE + 4) * (maxCaveats + 1) + 26,
//   minWidth: (AVATAR_SIZE + 4) * (maxCaveats + 1) + 26,
//   paddingRight: 20,
//   paddingLeft: 20,
//   overflow: "hidden",
//   whiteSpace: "nowrap",
//   flexShrink: 0
// });

const avatarStyle = {
  display: "inline-block",
  marginTop: 8,
  marginLeft: 2,
  border: `1px solid #efefef`,
  textAlign: "center",
  fontWeight: "bold",
  fontSize: 12,
  position: "relative"
};

export const CaveatAvatar = ({ score, count }) => {
let fontColor = score === "-3" ? "white" : "black";
  return (
    <Avatar
      style={avatarStyle}
      size={AVATAR_SIZE}
      backgroundColor={caveatColor(parseInt(score)).primary}
    >
      <span
        style={{
          position: "absolute",
          zIndex: 1,
          top: 1,
          left: -2,
          color: fontColor,
          width: 20,
          textAlign: "center",
          textShadow: "0px 1px 0px #00000047"
        }}
      >
        {count}
      </span>
    </Avatar>
  );
};
